<div class="stationWrap">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <div fxFlex fxLayoutAlign="start center">
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <mat-radio-group
                        *ngIf="!hideRadios"
                        style="padding-left: 10px"
                        (change)="onFilterSelection($event)"
                        class="hide-lt-lg">
                    @for (item of m_enumMediaTypeItems; track item) {
                        <mat-radio-button [value]="item" [checked]="item[0] === m_enumMediaTypeSelected">
                            <span style="padding-right: 5px">{{ item[1].toLowerCase() }}</span>
                        </mat-radio-button>
                    }
                </mat-radio-group>
            }
            @if (m_enumMediaTypeSelected == m_enumMediaType.ALL && !dialogGetAsset) {
                <a mat-icon-button
                   (click)="importResource()" color="warn"
                   [disabled]="groupCollection?.$?.import === '0'"
                   [ngStyle]="{'pointer-events': groupCollection?.$?.import === '0' ? 'none' : ''}"
                   matTooltip="{{'general.importResourceFromLibrary' | transloco}}">
                    <mat-icon>star</mat-icon>
                </a>
            }
            @if (accessConfig?.add !== false && !dialogGetAsset?.mode) {
                <a mat-icon-button (click)="uploadFiles()"
                   [disabled]="accessConfig.add === false" matTooltip="{{'general.upload' | transloco}}">
                    <mat-icon>attach_file</mat-icon>
                </a>
            }
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <a mat-icon-button (click)="clipboardOpenDialog()" matTooltip="{{'general.moveResourcesBetweenAccounts' | transloco}}">
                    <mat-icon>merge</mat-icon>
                </a>
            }
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <a mat-icon-button [disabled]="!dataSource || !lastGetTime" (click)="showResourceDashboard()" style="opacity: 0.7;" matTooltip="{{'general.viewResourceStats' | transloco}}">
                    <mat-icon>pie_chart</mat-icon>
                </a>

                <a mat-icon-button [disabled]="selection?.selected?.length !== 1 ||
                    (
                        selectedResource?.resource_type !== 'jpg'
                        && selectedResource?.resource_type !== 'jpeg'
                        && selectedResource?.resource_type !== 'gif'
                        && selectedResource?.resource_type !== 'svg'
                        && selectedResource?.resource_type !== 'png'
                    )"
                   (click)="onEditResource()" style="opacity: 0.7;" matTooltip="{{'general.editWithPaintBrush' | transloco}}" class="hide-xs">
                    <mat-icon>palette</mat-icon>
                </a>
            }
            @if (selection?.selected?.length > 0) {
                <a mat-icon-button (click)="onDelete()" matTooltip="{{'scenes.delete' | transloco}}">
                    <mat-icon>delete</mat-icon>
                </a>
            }
            <app-video-link style="display: inline-block;" videoLink="resources" class="hide-xs"></app-video-link>

        </div>
        <div style="margin-right: 10px;">
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <div class="d-flex-center">
                    <mat-form-field class="form-element">
                        <mat-label>{{ 'placeholder.filterList' | transloco }}</mat-label>
                        <input inputrestriction="basic1" matInput type="text" (keydown.control.a)="masterToggle()" (keyup)="applyFilter()" name="SearchDualList"
                               class="form-control" [(ngModel)]="globalFilter" autocomplete="off"/>
                        <a matSuffix aria-label="Clear" (click)="clearSelection()">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                    <mat-form-field class="form-element hide-lt-md" style="margin-left: 10px;">
                        <mat-select placeholder="{{'placeholder.filterCategory' | transloco}}" [(value)]="categorySelected"
                                    (selectionChange)="onCategoryChange($event)">
                            <mat-option>{{ 'general.noCategory' | transloco }}</mat-option>
                            @for (category of categories; track category) {
                                <mat-option [value]="category">
                                    {{ category }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            }
            @if (!dialogGetAsset) {
                <a mat-icon-button class="hide-gt-sm" style="margin-top: 5px;" (click)="toggleMinimize.emit();">
                    <mat-icon>settings</mat-icon>
                </a>
            }
        </div>
    </div>

    <mat-tab-group animationDuration="0ms" tabGroupDrag [selectedIndex]="autoSelectTabIndex" mat-stretch-tabs="false" mat-align-tabs="start">

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">view_quilt</mat-icon>
                {{ 'general.wall' | transloco }}
            </ng-template>
            <a (click)="theme=!theme" mat-icon-button class="thumb-view-button mini-button">
                @if (theme) {
                    <mat-icon style="color: white">width_normal</mat-icon>
                } @else {
                    <mat-icon style="color: white">width_full</mat-icon>
                }
            </a>
            <div fxLayout="row wrap" fxLayoutAlign="flex-start" class="flex-xs-center-center flex-xs-col" style="margin-top: 10px;">
                @for (resource of dataSourceThumbnails$ | async; track resource) {
                    <div class="thumbs"
                         [ngClass]="{'selected': selection.isSelected($any(resource?.resource_id)), 'fixed-width': theme}"
                         (click)="onSelectedThumb(resource)">
                        @if (resource?.resource_type !== 'mp4') {
                            <img class="thumb-img" [src]="(resource | PipeResourceUrl:resource:coreAppData).url" loading="lazy"
                                 onerror="src='./assets/images/no_image.png'">
                        }
                        @if (resource?.resource_type === 'mp4') {
                            <div class="thumb-video">
                                <vg-player>
                                    <vg-controls>
                                        <vg-play-pause></vg-play-pause>
                                        <vg-playback-button></vg-playback-button>
                                        <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                                        <vg-scrub-bar>
                                            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                                        </vg-scrub-bar>
                                        <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                                        <vg-mute></vg-mute>
                                        <vg-volume></vg-volume>
                                        <vg-fullscreen></vg-fullscreen>
                                    </vg-controls>
                                    <video id="singleVideo" [vgMedia]="$any(media)" #media [autoplay]="false" preload="auto">
                                        <source [src]="(resource | PipeResourceUrl:resource:coreAppData).videoUrl" type="video/mp4">
                                    </video>
                                </vg-player>
                            </div>
                        }
                        <div style="font-size: 11px;">
                            {{ resource.resource_name | PipeTruncate:['12'] }}.{{ resource.resource_type }}
                        </div>
                    </div>
                }
            </div>
            @if (!dataSource || !lastGetTime) {
                <div style="overflow: hidden; height: 150px">
                    <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
                    <br/>
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <mat-icon>hourglass_empty</mat-icon>
                        {{ 'placeholder.makeTakeMinute' | transloco }} ...
                    </div>
                </div>
            }
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">view_stream</mat-icon>
                {{ 'general.list' | transloco }}
            </ng-template>
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        @if (!dialogGetAsset && allowMultiSelect) {
                            <mat-checkbox (change)="$event ? masterToggle() : null"
                                          [checked]="selection.hasValue() && isAllSelected()"
                                          [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        }
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation(); resourceChecked(row.resource_id)"
                                      (change)="$event ? selection.toggle(row.resource_id) : null"
                                      [checked]="selection.isSelected(row.resource_id)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> {{ 'general.staus' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.$.connection == 2) {
                            <mat-icon class="status-icon" inline="true" style="color:yellow" svgIcon="">
                                check_circle
                            </mat-icon>
                        }
                        @if (element.$.connection == 1) {
                            <mat-icon class="status-icon" inline="true" style="color:green" svgIcon="">
                                check_circle
                            </mat-icon>
                        }
                        @if (element.$.connection == 0) {
                            <mat-icon class="status-icon" inline="true" style="color: red" svgIcon="">
                                error
                            </mat-icon>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'general.name' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.resource_name }}</td>
                </ng-container>
                <ng-container matColumnDef="type">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'general.type' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.resource_type }}</td>
                </ng-container>
                <ng-container matColumnDef="time">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'general.time' | transloco }}</th>
                    <td mat-cell
                        *matCellDef="let element"> {{ element.resource_date_modified | date }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="size">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'general.size' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.resource_bytes_total / 1000 }}K</td>
                </ng-container>
                <ng-container matColumnDef="category">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'general.category' | transloco }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.tree_path }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-tab>
    </mat-tab-group>


    <ng-container>
        <mat-paginator customPageSize style="padding-bottom: 10px; margin-bottom: 5px"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       [showFirstLastButtons]="true">
        </mat-paginator>
    </ng-container>
</div>
